import { createContext } from 'react';
import { IOnboardingDocuments } from '@efex-services/documents/documentsSvc';
import { ProofOfAddressDocumentReducerState } from './reducers/proofOfAddressDocumentReducer.types';
import {
  DeleteGovernmentIdDocument,
  GovermentIdReducerState,
} from './reducers/govermentIdReducer/types';

interface StakeHolderContextProps {
  proofOfAddressDocument: ProofOfAddressDocumentReducerState;
  setProofOfAddressDocument: (data: IOnboardingDocuments[]) => void;
  govermentIdDocuments: GovermentIdReducerState;
  setGovermentIdDocuments: (data: IOnboardingDocuments[]) => void;
  deleteProofOfAddressDocument: VoidFunction;
  addDocumentToDelete: (documentId: number) => void;
  deleteDocumensToDelete: () => Promise<void>;
  changeProofOfAddressDocument: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => void;
  getAllCurrentDocumentsIds: () => number[];
  handleChangeTypeOfGovernmentId: VoidFunction;
  deleteGovernmentIdDocument: (
    documentPlace: DeleteGovernmentIdDocument
  ) => void;
}

export default createContext<StakeHolderContextProps>({
  proofOfAddressDocument: [],
  setProofOfAddressDocument: () => {},
  govermentIdDocuments: {
    documentOne: null,
    documentTwo: null,
  },
  setGovermentIdDocuments: () => {},
  deleteProofOfAddressDocument: () => {},
  addDocumentToDelete: () => {},
  deleteDocumensToDelete: async () => {},
  changeProofOfAddressDocument: () => {},
  getAllCurrentDocumentsIds: () => [],
  handleChangeTypeOfGovernmentId: () => {},
  deleteGovernmentIdDocument: () => {},
});
